import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getFeedbackDone = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/feedback/done`, {
        headers: { Authorization: token }
    });
};

export const getFeedbackNonDone = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/feedback/non-done`, {
        headers: { Authorization: token }
    });
};

export const doneFeedback = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/feedback/done/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const nonDoneFeedback = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/feedback/undone/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const hideFeedback = async (id, formDate) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/feedback/hide/${id}`, formDate, {
        headers: { Authorization: token }
    });
};